<div [class.fa-center]="centered" class="spinner-container">
  <fa-icon [icon]="faSpinner" [size]="size" animation="spin-pulse"></fa-icon>
</div>
